module.exports = __webpack_public_path__ + "1b4daa060e12746cba52d655038e81f1.png";